import * as React from 'react';
import {Button, Form, Icon, Input} from 'antd';
import {FormComponentProps} from 'antd/lib/form';

import './LoginForm.css'
import locales from '../locales';

interface LoginFormProps extends FormComponentProps {
  onLoginBtnTapped: ((userName: string, password: string) => void);
}

class LoginForm extends React.Component<LoginFormProps, {}> {

  public render() {
    const {getFieldDecorator} = this.props.form;

    return (
      <div id="login-form-wrapper">
        <Form onSubmit={this.handleSubmit}>
          <Form.Item>
            {getFieldDecorator('userName', {
              rules: [
                {required: true, message: locales.username_missing},
              ],
            })(
              <Input
                prefix={<Icon type="user"/>}
                placeholder={locales.username}
                name="userName"
                autoCapitalize='none'
              />
            )}
          </Form.Item>
          <Form.Item>
            {getFieldDecorator('password', {
              rules: [{required: true, message: locales.password_missing}],
            })(
              <Input
                prefix={<Icon type="lock"/>}
                placeholder={locales.password}
                type="password"
                name="password"
              />
            )}
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" className="login-form-button">{locales.login}</Button>
          </Form.Item>
        </Form>
      </div>
    );
  }

  private handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    this.props.form.validateFields(((errors, values) => {
      if (!errors) {
        this.props.onLoginBtnTapped(values.userName, values.password);
      }
    }));
  };
}

export default Form.create<LoginFormProps>()(LoginForm);


// WEBPACK FOOTER //
// ./src/account/LoginForm.tsx